<template>
  <v-carousel
    vertical
    cycle
    height="400"
    hide-delimiter-background
    show-arrows-on-hover
    
  >
    <v-carousel-item v-for="(slide, i) in slides" :key="i">
      <ImageModel
        :imageName="slide.imageName"
        :alt="slide.alt"
        :parentFolder="parentFolder"
      ></ImageModel>
    </v-carousel-item>
  </v-carousel>
</template>

<script>
import ImageModel from "@/components/global/compnentsMixins/ImageModel.vue";
export default {
  components: {ImageModel},
 props:{ 
   slides:{
     type:Array
   },
   parentFolder:{
     type:String
   }
 }
 
};
</script>

<style lang="scss" scoped>
</style>
